<form *ngIf="transactionLineFormGroup" [formGroup]="transactionLineFormGroup">    
    <div class="grid">        
        <div class="col-12 input-field" *ngIf="isRate && !transactionLine.isGroup && transaction?.transactionType?.enableRate">
            <label for="capabilityId">Especialidad</label>
            <p-dropdown [(ngModel)]="selectedCapability" [ngModelOptions]="{standalone:true}" [options]="capabilities"
                (onChange)="selectCapability($event)" optionLabel="name" optionValue="id" [filter]="true" filterBy="name"
                appendTo="body" placeholder="Selecciona una especialidad" d-form-field-error></p-dropdown>
        </div>
        <div class="col-12 input-field" *ngIf="transaction?.transactionType?.enableRate && !transactionLine.isGroup">
            <label for="rateLineId">Baremo</label>
            <p-dropdown formControlName="rateLineId" [options]="rateLines" optionValue="id" optionLabel="displayName"
                appendTo="body" placeholder="Selecciona un código" (onChange)="onRateLineChange($event)"
                showClear [filter]="true" d-form-field-error>
                <ng-template let-rateLine pTemplate="item">
                    <div class="flex flex-column">
                        <div style="white-space: normal;max-width: 700px;">{{ rateLine.displayName }}</div>
                        <small style="font-size: 8px;">{{ getRate(rateLine.rateId)?.name }}</small>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-12 input-field" *ngIf="transaction?.transactionType?.enableTemplates">
            <label for="capabilityId">Tipo</label>
            <p-dropdown formControlName="transactionLineTemplateId" [options]="transactionLineTemplates"
                (onChange)="selectTransactionLineTemplate($event)" optionLabel="name" optionValue="id" [filter]="true" filterBy="name"
                appendTo="body" placeholder="Sin plantilla" d-form-field-error></p-dropdown>
        </div>
        <ng-container *ngIf="transaction?.transactionType?.enableTemplates">
            <ng-container *ngFor="let field of templateConfig.fields">
                <div class="col-12 input-field" *ngIf="field.controlType == 'text'">
                    <label [for]="field.name">{{ field.label }}</label>
                    <input pInputText type="text" [(ngModel)]="templateLineData[field.name]" [ngModelOptions]="{standalone:true}" [required]="field.required" d-form-field-error>
                    <small *ngIf="field.helpText" class="p-text-secondary">{{ field.helpText }}</small>
                </div>
                <div class="col-12 input-field" *ngIf="field.controlType == 'number'">
                    <label [for]="field.name">{{ field.label }}</label>
                    <p-checkbox [(ngModel)]="templateLineData[field.name]" [ngModelOptions]="{standalone:true}" d-form-field-error [binary]="true"></p-checkbox >
                    <small *ngIf="field.helpText" class="p-text-secondary">{{ field.helpText }}</small>
                </div>
                <div class="col-12 input-field" *ngIf="field.controlType == 'checkbox'">
                    <label [for]="field.name">{{ field.label }}</label>
                    <input pIn type="checkbox" [(ngModel)]="templateLineData[field.name]" [ngModelOptions]="{standalone:true}" [required]="field.required" d-form-field-error>
                    <small *ngIf="field.helpText" class="p-text-secondary">{{ field.helpText }}</small>
                </div>
                <div class="col-12 input-field" *ngIf="field.controlType == 'textarea'">
                    <label [for]="field.name">{{ field.label }}</label>
                    <textarea #autoGrowTextarea pInputTextarea rows="4" style="max-height: 220px; overflow-y: hidden; resize: none;" (input)="stringUtilsService.ResizeTextarea($event, 220)" (focus)="stringUtilsService.ResizeTextarea($event, 220)" [(ngModel)]="templateLineData[field.name]" [ngModelOptions]="{standalone:true}" [required]="field.required" d-form-field-error></textarea>
                    <small *ngIf="field.helpText" class="p-text-secondary">{{ field.helpText }}</small>
                </div>
            </ng-container>
        </ng-container>
        <div class="col-12 input-field" *ngIf="!transaction?.transactionType?.enableTemplates || transactionLineFormGroup.get('transactionLineTemplateId')?.value == null">
            <label for="notes">Descripción</label>
            <textarea #autoGrowTextarea pInputTextarea rows="4" 
                style="max-height: 220px; overflow-y: hidden; resize: none;" (input)="stringUtilsService.ResizeTextarea($event, 220)"
                 (focus)="stringUtilsService.ResizeTextarea($event, 220)" formControlName="description" 
                d-form-field-error></textarea>
            <small class="p-error" *ngIf="formValidationService.getValidationMessage(transactionLineFormGroup, 'description', { }) as descriptionError">{{ descriptionError }}</small>

        </div> 
    </div>
    <div class="grid">
        <div class="col input-field" *ngIf="!transactionLine.isGroup">
            <label for="quantity">Cantidad</label>
            <input formControlName="quantity" pInputText type="number" d-form-field-error (input)="calculatePrices($event)">
        </div>
        <div class="col input-field" *ngIf="!transactionLine.isGroup && transaction?.transactionType?.enablePrice">
            <label for="price">Precio</label>
            <input formControlName="price" pInputText type="number" d-form-field-error (input)="calculatePrices($event)">
        </div>
        <div class="col input-field" *ngIf="!transactionLine.isGroup && transaction?.transactionType?.enableDiscount">
            <label for="discountPercent">Descuento (%)</label>
            <input formControlName="discountPercent" pInputText type="number" d-form-field-error (input)="calculatePrices($event)">
            <label class="mt-2">
                {{ transactionLineFormGroup.get('discountAmount')?.value | currency:'EUR':'symbol':'1.2-2' }}
            </label>            
        </div>
        <div class="col input-field" *ngIf="!transactionLine.isGroup && transaction?.transactionType?.enableDiscount">
            <label for="incrementPercent">Incremento (%)</label>
            <input formControlName="incrementPercent" pInputText type="number" d-form-field-error (input)="calculatePrices($event)">
            <label class="mt-2">
                {{ transactionLineFormGroup.get('incrementAmount')?.value | currency:'EUR':'symbol':'1.2-2' }}
            </label>            
        </div>   
        <div class="col input-field" *ngIf="transaction?.transactionType?.code == 'purchase_order'">
            <label for="discountAmount">Descuento (€)</label>
            <input formControlName="discountAmount" pInputText type="number" d-form-field-error (input)="calculatePricePurchaseOrder($event)">
        </div>
        
        <div class="col input-field" *ngIf="!transactionLine.isGroup && transaction?.transactionType?.enablePrice">
            <label for="subtotal">Base imponible</label>
            <input formControlName="subtotal" pInputText type="number" d-form-field-error (input)="calculatePrices($event)">
        </div>          
        <div class="col input-field" *ngIf="!transactionLine.isGroup && transaction?.transactionType?.enableTax">
            <label for="code">Impuestos(%)</label>
            <p-dropdown formControlName="taxPercent" [options]="taxes"
                optionLabel="name" optionValue="percent" appendTo="body" filterBy="name"
                placeholder="Seleccione opción" (onChange)="calculatePrices($event)" d-form-field-error></p-dropdown>                            
            <label class="mt-2">
                {{ transactionLineFormGroup.get('taxAmount')?.value | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>
        <div class="col input-field" *ngIf="!transactionLine.isGroup && transaction?.transactionType?.enablePrice">
            <label for="total">Importe</label>
            <!--<input pInputText type="text" value="{{ 
                (transactionLineFormGroup.get('subtotal')?.value + 
                transaction?.transactionType?.enableTax ?transactionLineFormGroup.get('taxAmount')?.value : 0) 
                + transactionLineFormGroup.get('incrementAmount')?.value - transactionLineFormGroup.get('discountAmount')?.value | currency:'EUR':'symbol':'1.2-2' }}" disabled>-->
            <input pInputText type="text" value="{{ 
                (transactionLineFormGroup.get('subtotal')?.value + 
                (transaction?.transactionType?.enableTax ? transactionLineFormGroup.get('taxAmount')?.value : 0))  | currency:'EUR':'symbol':'1.2-2' }}" disabled>
        </div>

        <div class="col-12" *ngIf="uploadDocument">
            <p-fileUpload mode="basic" chooseIcon="pi pi-upload" (onSelect)="onFileSelect($event)" [multiple]="true"
                chooseLabel="Seleccionar fichero" />
        </div>
    </div>                                                                        
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && transactionLine.id" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>    
</form>
<p-confirmDialog />